module.exports = __webpack_public_path__ + "assets/img/hcbbt1.4ddbb353.png";